module.exports = __webpack_public_path__ + "img/图灵.1a325597.png";